module.exports = ".custom-margin{\r\n    margin-top:30px;\r\n    margin-bottom: 50px;\r\n    }\r\n    .btn-mob-width{\r\n        width: 100%;\r\n        margin-top: 20px;\r\n        margin-bottom: 20px;\r\n    }\r\n    .margin-top{\r\n    margin-top:10px;\r\n}\r\n    .margin-radio-top{\r\n    margin-top: 5px;\r\n}\r\n    .margin-bottom{\r\n    margin-bottom: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/loss-data-dashboard/incident-by-years/large-view/incident-by-year-large-chart.component.css
// module id = ./src/app/modules/loss-data-dashboard/incident-by-years/large-view/incident-by-year-large-chart.component.css
// module chunks = main